import React from 'react'
import { Paper, Box, Grid, Typography, makeStyles, useTheme } from '@material-ui/core'
import CardBg from '../assets/app_card_bg.svg';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    root: {
        "& *": {
            textAlign: 'start'
        },
        borderRadius: 8,
        minWidth: 290,
        boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,

    },
    name: {
        fontWeight: 'bold',
        fontSize: 18,
        lineHeight: '25px'
    },
    courseName: {
        marginBottom: 16,
        color: theme.palette.KenColors.neutral40
    },
    applicationId: {
        color: theme.palette.KenColors.neutral10,
        fontSize: 14
    },
    content: {
        backgroundImage: `url(${CardBg})`,
        backgroundSize: 'cover',
        color: 'white',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    footer: {

    },
    status: {
        color: theme.palette.KenColors.tertiaryGreen400
    },
    date: {
        color: theme.palette.KenColors.neutral100

    }

}));



export default function ApplicationCard(props) {
    // console.log(props,'pros..........');
    const classes = useStyles();
    const {
        ApplicationNo,
        InstituteName,
        ApplicantName,
        Application_type__c,
        ApplicationDate,
        ApplicationStatus,
        index = 0,
        Id
    } = props;


    const theme = useTheme();
    const bgColors = [
        theme.palette.KenColors.tertiaryGreen400,
        theme.palette.KenColors.tertiaryBlue400,
        theme.palette.KenColors.tertiaryYellow400,
        theme.palette.KenColors.tertiaryPurple400,
        theme.palette.KenColors.tertiaryTeal400,
        theme.palette.KenColors.tertiaryRed400,
    ];
    return (
        <Paper className={classes.root}>
            <Box p={4} pb={3} className={classes.content}
                style={{ backgroundColor: bgColors[Math.floor(index % bgColors.length)] }}>
                <Grid container >
                    <Grid item>
                        <Typography className={classes.name}>
                            {ApplicantName}
                        </Typography>
                        <Typography className={classes.courseName}>
                            {Application_type__c}
                        </Typography>
                        <Typography className={classes.applicationId}>
                            Application Id: {Id}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box className={classes.footer} px={4} py={2}>
                <Grid container>
                    <Grid item>
                        <Typography className={classes.status} >
                            {ApplicationStatus}
                        </Typography>
                        <Typography className={classes.date}>
                            Submitted On {moment(ApplicationDate).format('DD MMM YYYY')}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    )
}
